import { FormControl } from '@angular/forms';

import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../BaseComponent';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { ApplicationRequesterDateAdapter } from 'src/app/services/DateAdapter';
import { SessionService } from 'src/app/session-service.service';
import { ComponentCommunicationService } from 'src/app/component-communication.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-date-input',
  templateUrl: 'date-input.html',
  styleUrls: ['date-input.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: DateAdapter, useClass: ApplicationRequesterDateAdapter },
  ],
})
export class DateInputComponent extends BaseComponent implements OnInit {
  @Input()
  hasDefaultDate: boolean;

  @Input()
  min: Date;

  @Input()
  startView = undefined;

  @Input()
  inputBorderColor: string;

  @Input()
  inputColor: string;

  @Input()
  fontColor: string;

  @Input()
  fontSize: string;

  @Input()
  additionalInfoInsurer: string;

  @Input()
  secondInsured: boolean;

  @Input()
  datePlaceholder: string;

  @Input()
  dateMask: string;

  @Output()
  selectionChange: EventEmitter<MatSelectChange>;
  date: Date;
  @Input()
  isInsuredPresent: boolean;

  defaultValidations: [{ type: string; message: any }];
  controlType = this.constructor.name;
  initialDateValue: Date;

  constructor(translateService: TranslateService,
              sessionService: SessionService,
              private componentCommunicationService: ComponentCommunicationService) {
    super(translateService, sessionService);
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
    } catch (e) {
      console.error(
        `Failed initializing toggle-input with placeholder ${this.placeholder}`
      );
    }
    if (this.hasDefaultDate) {
      this.control.setValue(new Date());
    }
    if (!this.isInsuredPresent){
      this.isInsuredPresent = false;
    }
    // load the date after all components are loaded
    setTimeout(() => { this.initialDateValue = this.control.value; }, 0);
  }

  get dateInitialValue(): Date {
    return this.initialDateValue;
  }

  openPopup(): void {
    this.componentCommunicationService.loadDialog(this.additionalInfoInsurer);
  }

  valueChanged(event): void {
    this.date = new Date(
      event.value
    );
    this.control.setValue(this.date);
  }
}
